import { Card, Text, Title } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FormBlockedNik from '../../components/forms/FormBlockedNik';
import { useDispatch, useSelector } from 'react-redux';
import { actionUpdateNikStatusBulk, clearRedux, fetchCheckStatusBulk } from './action';
import RenderModal from './modal';
import { fetchReasons } from '../SettingReasonBlockId/actions';
import { AppContext, ToastrContext } from '../../contexts';
import dayjs from 'dayjs';
import { useTimer } from 'react-timer-hook';
import { useScheduledPolling } from '../../utils/hooks';
import { RenderModalLimitMaxCsv } from '../MAPFeatureActivation/Modal';

export default function NikBlockedBulk() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const [modal, setModal] = useState({
    actionType: '',
    variant: '',
    opened: false
  });
  const { updateNikStatusBulk, dataCheckStatusBulk } = useSelector((state) => state.nikManagement);
  const { dataReason, dataReasonDetail } = useSelector((s) => s.settingReasonBlockId);
  // const [, setIsBlocked] = useState(false);
  const [isTooManyRequests, setIsTooManyRequests] = useState(false);
  const dateNow = new Date();
  const { minutes, seconds, restart } =
    useTimer({
      expiryTimestamp: dateNow,
      onExpire: () => {
        dispatch(clearRedux('updateNikStatusBulk'));
        setIsTooManyRequests(false);
        // setIsBlocked(false);
      },
      autoStart: false
    });
  const { startPolling, stopPolling, secondsElapsed } = useScheduledPolling({
    action: (requestId) => dispatch(fetchCheckStatusBulk(requestId)),
    interval: 5000,  // Fetch every 5s
    duration: 30000, // Stop after 30s
    onComplete: () => { }
  });

  const statusResponseBulkHandler = (response) => {
    if (response.success) {
      setModal({
        actionType: 'block',
        variant: 'processing_bulk',
        opened: true
      });
      const requestId = response?.data?.id;
      if (requestId) {
        startPolling(requestId);
      }
      // setIsBlocked(false);
    } else if (response.status === 'CSV_MAX_LIMIT') {
      setModal({
        variant: 'limitCsv',
        opened: true
      });
      // setIsBlocked(false);
    }
    else if (response.status === 'TOO_MANY_REQUEST') {
      setToastr({
        visible: true,
        type: 'danger',
        desc: response?.message || 'Terlalu banyak permintaan, silakan coba lagi nanti'
      });
      const newExpiry = new Date();
      newExpiry.setSeconds(newExpiry.getSeconds() + response?.data?.countdownTime);
      restart(newExpiry);
      setIsTooManyRequests(true);
      // setIsBlocked(false);
    }
  };

  const handleSubmit = (data) => {
    const [startDate, endDate] = data.period || [];
    const bodyReq = {
      'actionType': 'block',
      'startDate': startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
      'endDate': endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
      'reasonId': data.reasonId || '',
      'reasonDetailId': data.reasonDetailId || '',
      'file': data.file[0] || null,
      'supportDocument': data.supportDocument || null,
    };
    const formData = new FormData();
    Object.keys(bodyReq).forEach(key => {
      formData.append(key, bodyReq[key]);
    });
    dispatch(actionUpdateNikStatusBulk(formData, statusResponseBulkHandler));
    // setIsBlocked(true);
  };

  useEffect(() => {
    if (dataCheckStatusBulk?.data?.totalProcess <= 0) {
      stopPolling();
      navigate('/customer-setting/status/block');
      dispatch(clearRedux('dataCheckStatusBulk'));
    }
  }, [dataCheckStatusBulk]);

  useEffect(() => {
    dispatch(fetchReasons('dataReason'));
    dispatch(fetchReasons('dataReasonDetail'));
    setBreadcrumbs([
      { name: 'Blokir & Aktifkan NIK', to: '/customer-setting' },
      'Blokir NIK Pelanggan'
    ]);
    dispatch(clearRedux('dataCheckStatusBulk'));
  }, []);


  return (
    <div>
      <Card px={24} radius={'12px'} withBorder>
        <Card.Section p="md">
          <Title fz={30} order={4}>Blokir NIK Pelanggan Sekaligus</Title>
          <Text c={'#52575C'} fw={400} mb="md" size="md">
            Blokir NIK pelanggan sekaligus dengan template CSV berdasarkan nomor NIK pelanggan.
          </Text>
          <FormBlockedNik
            dataReason={dataReason}
            dataReasonDetail={dataReasonDetail}
            handleSubmit={handleSubmit}
            isBulk={true}
            isLoading={updateNikStatusBulk.isLoading}
            isTooManyRequests={isTooManyRequests}
            minute={minutes}
            navigate={navigate}
            second={seconds}
            updateNikStatusBulk={updateNikStatusBulk} />
        </Card.Section>
      </Card>
      {modal.variant === 'processing_bulk' && <RenderModal
        actionType="block"
        countDownStatus={secondsElapsed}
        // data={updateNikStatusBulk}
        handledCloseModal={() => {
          // dispatch(clearRedux('updateNikStatusBulk'));
          // setModal({
          //   actionType: 'block',
          //   variant: 'reason',
          //   opened: false
          // });
          // navigate('/customer-setting');
        }}
        handleVisitStatusPage={() => {
          stopPolling();
          navigate('/customer-setting/status/block');
        }}
        opened={modal.opened}
        variant={modal.variant} withCloseButton={false} />}
      {modal.variant === 'limitCsv' &&
        <RenderModalLimitMaxCsv
          message={<>Maksimal jumlah NIK pelanggan yang dapat diproses <strong>
            100.000 NIK pelanggan</strong>
            . Perbarui file data pelanggan dan coba lagi.</>}
          onClose={() => setModal({
            opened: false,
            variant: modal.variant,
            actionType: modal.actionType
          })}
          opened={modal.opened}
        />}
    </div>
  );
}
